/*
 * Datazoom, Inc ("COMPANY") CONFIDENTIAL
 * Copyright (c) 2017-2018 [Datazoom, Inc.], All Rights Reserved.
 *
 * This file is subject to the terms and conditions defined in
 * file 'LICENSE.txt', which is part of this source code package.
 */

import axios from "axios";
import qs from "qs";
import {
  baseApiV2,
  baseApiV2_1,
  baseApiV2_2,
  baseApiV3,
  baseApiV3_2,
} from "../../constants/Presets";
// function that makes the api request and returns a Promise for response
export function FetchCollectors(payload) {
  let url;
  url = `${baseApiV2_1}collector_config/list?`;
  const params = [];
  /* istanbul ignore if */
  if (payload.query) {
    const query = encodeURIComponent(payload.query).toString();
    params.push(`query=${query}`);
  }
  const field = payload.field || "";
  params.push(`field=${field}`);
  const order = payload.order || "";
  params.push(`order=${order}`);
  const page = payload.page || 0;
  params.push(`page=${page}`);
  const size = payload.size || 0;
  params.push(`size=${size}`);
  const customerCode = payload.companyId || "";
  params.push(`company_id=${customerCode}`);
  /* istanbul ignore if */
  if (payload.projectId) {
    const productId = payload.projectId || "";
    params.push(`project_id=${productId}`);
  }
  /* istanbul ignore if */
  if (payload.filters) {
    const filter = encodeURIComponent(JSON.stringify(payload.filters)) || null;
    params.push(`filters=${filter}`);
  }
  /* istanbul ignore if */
  if (payload.status !== "") {
    const disabled = payload.status === 0;
    params.push(`disabled=${disabled}`);
  }
  const paramStr = params.join("&");

  return axios.get(url + paramStr);
}
/* istanbul ignore next */
export function CreateCollector({ collector, player }) {
  return axios({
    method: "post",
    url: `${baseApiV2}config/save`,
    data: collector,
    params: {
      playerVersion: player ? player.version : "0",
      playerDescription: player ? player.alt : "",
    },
  });
}
/* istanbul ignore next */
export function FetchACollector(collector) {
  return axios({
    method: "get",
    url: `${baseApiV2_2}collector_config/${collector}`,
  });
}
/* istanbul ignore next */
export function EnableCollector(id) {
  return axios({
    method: "post",
    data: qs.stringify({
      id,
    }),
    url: `${baseApiV2}config/makeActive/`,
  });
}
/* istanbul ignore next */
export function DisableCollector(id) {
  return axios({
    method: "post",
    data: qs.stringify({
      id,
    }),
    url: `${baseApiV2}config/makeDisabled/`,
  });
}
/* istanbul ignore next */
export function FetchCollectorApiKey(collectorId) {
  return axios({
    method: "get",
    url: `${baseApiV2}collector/apiKey/${collectorId}`,
  });
}
/* istanbul ignore next */
export function RegenerateCollectorApiKey(collectorId) {
  return axios({
    method: "patch",
    url: `${baseApiV2}collector/apiKey/regenerate/${collectorId}`,
  });
}
/* istanbul ignore next */
export function DeleteCollector(collector) {
  const url = `${baseApiV2}config/collector/delete?collector_config_id=${collector}`;
  return axios.delete(url);
}

// export function UpdateCollector({ collector }) {
//   const param = {
//     projectId: collector.projectId,
//     name: collector.configName,
//     disabled: collector.disabled,
//   };
//   return axios({
//     method: "patch",
//     url: `${baseApiV2}config/save?configuration_id=${collector.configId}`,
//     data: param,
//   });
// }
/* istanbul ignore next */
export function UpdateLinkedCollector({ collector }) {
  const param = {
    projectId: collector.projectId,
  };
  return axios({
    method: "patch",
    url: `${baseApiV2}config/save?configuration_id=${collector.configId}`,
    data: param,
  });
}
/* istanbul ignore next */
export function UpdateCollector(payload) {
  return axios({
    method: "patch",
    url: `${baseApiV2_2}collector_config/save?configuration_id=${payload.id}`,
    data: payload.collector,
  });
}
/* istanbul ignore next */
export function FetchACollectorConfigStats(payload) {
  const url = `${baseApiV2}dataUsage/collector?`;
  const params = [];
  params.push(`from_date=${payload.fromDate}`);
  params.push(`to_date=${payload.toDate}`);
  params.push(`configuration_id=${payload.configId}`);
  const paramStr = params.join("&");
  return axios.get(url + paramStr);
}
/* istanbul ignore next */
export function FetchCollectorPlatforms(data) {
  const params = [];
  params.push(`plugin=${data?.plugin}`);
  if (data && data.companyId) {
    params.push(`companyId=${data?.companyId}`);
  }
  const paramStr = params.join("&");
  const url = `${baseApiV3}collector/list?`;
  return axios.get(url + paramStr);
}
/* istanbul ignore next */
export function FetchMediaPlugins(app_collector_id) {
  const url = `${baseApiV3}collector/media_player_plugins?app_collector_id=${app_collector_id}`;
  return axios.get(url);
}
/* istanbul ignore next */
export function CreateCollectorConfiguration(payload) {
  return axios({
    method: "post",
    url: `${baseApiV2_1}collector_config`,
    data: payload,
  });
}
/* istanbul ignore next */
export function FetchCollAdFrameworkList(collector) {
  return axios({
    method: "get",
    url: `${baseApiV3_2}collector/get_adframeworks/${collector}`,
  });
}
/* istanbul ignore next */
export function FetchCollectorChangeLog(id) {
  const url = `${baseApiV2_2}collector_config/changeLog/${id}`;
  return axios({
    method: "get",
    url,
  });
}
